import type { AtribuicaoListaEspera } from "@ida/core";

type Props = Record<string, string>;
interface Estado { primeira: Props; ultima: Props; remarketing?: Props }
const CHAVE_JORNADA = "ida.atribuicao.jornada.v1";
const CHAVE_SESSAO_JORNADA = "ida.atribuicao.toques.v1";
const CAMPOS = { utm_source: "origem", utm_medium: "midia", utm_campaign: "campanha",
  utm_content: "criativo", utm_term: "termo", campaign_id: "campanha_id",
  ad_id: "anuncio_id", creative_id: "criativo_id", creative_version: "criativo_versao" } as const;
function seguro(v: string | null | undefined): string | undefined {
  if (!v || v.includes("@") || /\b\d{3}[.-]?\d{3}[.-]?\d{3}[-/]?\d{2}\b/.test(v)) return;
  return v.slice(0, 160);
}
function prefixar(prefixo: string, dados: Props): Props {
  return Object.fromEntries(Object.entries(dados).map(([k,v]) => [prefixo+k,v]));
}
export function contextoJornada(storage: Pick<Storage,"getItem">): Props {
  try {
    const e: Estado = JSON.parse(storage.getItem(CHAVE_JORNADA) ?? "null");
    if (!e?.primeira || !e?.ultima) return {};
    return { ...prefixar("aquisicao_primeira_",e.primeira), ...prefixar("aquisicao_ultima_",e.ultima),
      ...(e.remarketing ? prefixar("remarketing_ultimo_",e.remarketing) : {}) };
  } catch { return {}; }
}
export function registrarToqueJornada({ url, referencia, agora, primeira, storage, sessao }: {
  url: string; referencia: string; agora: number; primeira: AtribuicaoListaEspera | undefined;
  storage: Pick<Storage,"getItem"|"setItem">; sessao: Pick<Storage,"getItem"|"setItem">;
}): Props | undefined {
  try {
    const u = new URL(url), params=u.searchParams;
    let ref=""; try { const r=new URL(referencia); if(r.hostname!==u.hostname) ref=r.hostname; } catch {}
    const anteriorSessao=JSON.parse(sessao.getItem(CHAVE_SESSAO_JORNADA) ?? "null");
    const sessaoAtiva=anteriorSessao && agora-anteriorSessao.em < 30*60*1000;
    const marcado=Boolean(params.get("utm_source") || params.get("utm_campaign"));
    // Mudanças internas não criam novos pontos de aquisição.
    if (!marcado && !ref && sessaoAtiva) return;
    const toque: Props={ em:new Date(agora).toISOString(), pagina:u.pathname.slice(0,120), origem:ref||"direto" };
    for(const [param,campo] of Object.entries(CAMPOS)) { const v=seguro(params.get(param)); if(v) toque[campo]=v; }
    if(ref) toque.referencia=ref;
    toque.tipo=params.get("utm_marketing")==="remarketing" || /^RM_/i.test(toque.campanha ?? "") ? "remarketing" : "aquisicao";
    const assinatura=JSON.stringify([toque.origem,toque.midia,toque.campanha,toque.criativo,toque.anuncio_id,toque.criativo_id,toque.criativo_versao,toque.tipo]);
    const vistos: string[]=sessaoAtiva ? anteriorSessao.vistos : [];
    if(vistos.includes(assinatura)) return;
    let estado: Estado | null=JSON.parse(storage.getItem(CHAVE_JORNADA) ?? "null");
    if (!estado) {
      const inicial: Props={};
      for(const [k,v] of Object.entries({ origem:primeira?.origem,midia:primeira?.midia,campanha:primeira?.campanha,criativo:primeira?.conteudo,referencia:primeira?.referencia,pagina:primeira?.paginaEntrada,em:primeira?.primeiroAcessoEm })) {
        const valor=seguro(v); if(valor) inicial[k]=valor;
      }
      const nova=primeira?.primeiroAcessoEm && Math.abs(agora-Date.parse(primeira.primeiroAcessoEm))<1000;
      estado={primeira: nova ? {...toque,...inicial} : inicial, ultima:toque};
    }
    estado.ultima=toque;
    if(toque.tipo==="remarketing") estado.remarketing=toque;
    storage.setItem(CHAVE_JORNADA,JSON.stringify(estado));
    sessao.setItem(CHAVE_SESSAO_JORNADA,JSON.stringify({em:agora,vistos:[...vistos.slice(-49),assinatura]}));
    return { ...contextoJornada(storage), ...prefixar("toque_",toque) };
  } catch { return; }
}
